// frontend/src/components/IndustrialLogo.js
import React from 'react';

const IndustrialLogo = ({ className = "w-10 h-10", showText = true }) => {
  return (
    <div className={`flex items-center space-x-3 space-x-reverse ${className}`}>
      {/* لوگوی SVG چرخ دنده صنعتی */}
      <div className="relative">
        <svg 
          width={className.includes('w-') ? className.split('w-')[1].split(' ')[0] : "40"} 
          height={className.includes('h-') ? className.split('h-')[1].split(' ')[0] : "40"}
          viewBox="0 0 100 100" 
          className="text-yellow-400"
          fill="currentColor"
        >
          {/* حلقه بیرونی */}
          <circle cx="50" cy="50" r="45" fill="none" stroke="currentColor" strokeWidth="3" />
          
          {/* چرخ دنده اصلی */}
          <g transform="rotate(15 50 50)">
            {/* دندانه‌های چرخ دنده */}
            {[...Array(8)].map((_, i) => (
              <rect
                key={i}
                x="47.5"
                y="5"
                width="5"
                height="15"
                rx="2.5"
                transform={`rotate(${i * 45} 50 50)`}
              />
            ))}
            
            {/* حلقه داخلی */}
            <circle cx="50" cy="50" r="25" fill="none" stroke="currentColor" strokeWidth="2" />
            
            {/* چرخ دنده داخلی */}
            <g transform="rotate(-15 50 50)">
              {[...Array(6)].map((_, i) => (
                <rect
                  key={i}
                  x="47.5"
                  y="30"
                  width="5"
                  height="10"
                  rx="2.5"
                  transform={`rotate(${i * 60} 50 50)`}
                />
              ))}
            </g>
            
            {/* مرکز لوگو */}
            <circle cx="50" cy="50" r="8" fill="currentColor" />
          </g>
          
          {/* شعاع‌های انرژی */}
          <g className="animate-pulse">
            {[...Array(4)].map((_, i) => (
              <line
                key={i}
                x1="50"
                y1="50"
                x2="50"
                y2="10"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                transform={`rotate(${i * 90} 50 50)`}
                opacity="0.6"
              />
            ))}
          </g>
        </svg>
        
        {/* انیمیشن چرخش */}
        <style jsx>{`
          svg {
            animation: rotate 20s linear infinite;
          }
          @keyframes rotate {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>

      {/* متن لوگو */}
      {showText && (
        <div className="flex flex-col">
          <span className="text-white font-bold text-xl leading-5">ESPADANA</span>
          <span className="text-gray-400 text-xs leading-4">Techno polymer</span>
        </div>
      )}
    </div>
  );
};

export default IndustrialLogo;